import { createContext, useContext, useState, useEffect } from "react";
import { data, useNavigate } from "react-router-dom";
import axios from "axios";
import { removeCookie, setCookie, getCookie } from "../../Utils/cookies";

axios.defaults.withCredentials = true;

// Create context
const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [empData, setEmpData] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(true);
  const navigate = useNavigate();

  // Restore auth state on load (if cookies exist)
  useEffect(() => {
    // const token = getCookie("token");
    const storedEmpData = getCookie("empData");
    if (storedEmpData) {
      setEmpData(JSON.parse(storedEmpData));
    }
    setLoadingAuth(false);
  }, []);

  // Login API call
  const loginAPI = async (loginData, setError, setLoading) => {
    setLoading(true);
    //  console.log("loginData : ",loginData)
    try {
      // const response = await axios.post(
      //   `${process.env.REACT_APP_SERVER_ADDRESS}/auth/login`,
      //   loginData,
      // );
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_ADDRESS}/auth/login`,
        loginData,
      );

      const { data } = response.data;
      // console.log("my Token ", response)

      // Set cookies and state
      // setCookie("token", token, { expires: 0.5 }); // 12 hrs
      setCookie("empData", JSON.stringify(data));
      setCookie("startCnt", 0);

      setCookie("endCnt", 120);

      setEmpData(data);

      // console.log("login response ", response);

      return response.data;
    } catch (error) {
      console.error("Login Error:", error);
      alert(error?.response?.data?.message);
      setError(
        error.response?.data?.message || "Login failed. Please try again."
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  // console.log("emp : ",empData)

  // Logout API call
  const logoutAPI = async (setError) => {
    try {
      await axios.get(`${process.env.REACT_APP_SERVER_ADDRESS}/auth/logout`);

      // Clear cookies and state
      removeCookie("token");
      removeCookie("empData");
      removeCookie("startCnt");
      removeCookie("endCnt");

      setEmpData(null);
      navigate("/");

      return true;
    } catch (error) {
      console.error("Logout Error:", error);
      setError(
        error.response?.data?.message || "Logout failed. Please try again."
      );
      return false;
    }
  };

  return (
    <AuthContext.Provider value={{ loginAPI, logoutAPI, empData, setEmpData, loadingAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
